// material-ui
import {
    Box,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TablePagination,
    TableRow,
    Modal,
    Checkbox,
    Grid,
    ToggleButtonGroup,
    ToggleButton,
    Button,
    Typography,
    TextField,
    MenuItem,
    Divider,
    Autocomplete
} from '@mui/material';
import { ManageAccounts, Cancel, ArrowBack } from '@mui/icons-material';
import { styled, useTheme } from '@mui/material/styles';
import { useState, useEffect } from 'react';
import TasklistFilter from './TasklistFilter';
import { deepPurple, grey } from '@mui/material/colors';
import useFetchData from 'hooks/useFetchData';
import { axiosInstance } from 'utils/axios';
import { useSelector } from 'react-redux';
import { selectCurrentToken } from 'features/auth/authSlice';
import { borderRadius, color, height, padding, width } from '@mui/system';
import Select, { SingleValue } from "react-select";
import { successAlert, errorAlert, warningAlert } from 'ui-component/Toasts';
import { useTranslation } from "react-i18next";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
    '& .MuiToggleButtonGroup-grouped': {
        //   margin: theme.spacing(2),

        //   '&.Mui-disabled': {
        //     border: 0,
        //   },
        '&:not(:first-of-type)': {
            borderRadius: theme.shape.borderRadius
        },
        '&:first-of-type': {
            borderRadius: theme.shape.borderRadius
        }
    }
}));

const StyledToggleButton = styled(ToggleButton)({
    border: 2,
    borderColor: deepPurple[500],
    backgroundColor: grey[300],
    '&.Mui-selected, &.Mui-selected:hover': {
        color: 'white',
        backgroundColor: deepPurple[500]
    }
});

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: 800,
    width: '90%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    padding: '20px',
    borderRadius: '10px',
    height: '100%'
};

const options = [
    { value: 'chocolate', label: 'Chocolate' },
    { value: 'strawberry', label: 'Strawberry' },
    { value: 'vanilla', label: 'Vanilla' }
];

const CustomerTasklistModal = ({
    editCustomerModalOpen,
    setEditCustomerModalOpen,
    activeTab,
    buttonName,
    customerRow,
    fetchCustomers,
    handleRefresh
}) => {
    const { t } = useTranslation();
    const token = useSelector(selectCurrentToken);

    const [view, setView] = useState('allTasks');
    const [customerID, setCustomerID] = useState(0);

    const [depositAmount, setDepositAmount] = useState(0);
    const [withdrawalAmount, setWithdrawalAmount] = useState(0);
    const [vipLevelID, setVIPLevelID] = useState(0);
    const [depositTabUpdateButtonDisabled, setDepositTabUpdateButtonDisabled] = useState(false);
    
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(100);

    const handleChange = (event, nextView) => {
        setView(nextView);
    };

    const handleOpenModal = () => {
        setView(activeTab);
        setEditCustomerModalOpen(true);
    };

    useEffect(() => {
        if (editCustomerModalOpen && customerRow?.id) {
            setCustomerID(customerRow.id);
            setView(activeTab); // or set to 'resetTasklist' by default
        }
    }, [editCustomerModalOpen, customerRow]);

    function PersonalDetailsTab() {
        const [loginUserName, setLoginUserName] = useState(customerRow.loginUserName);
        const [name, setName] = useState(customerRow.name);
        const [phoneNumber, setPhoneNumber] = useState(customerRow.phoneNumber);

        const [updateButtonDisabled, setUpdateButtonDisabled] = useState(false);
        const submitUpdateCustomerProfile = async () => {
            setUpdateButtonDisabled(true);

            try {
                const res = await axiosInstance.put(
                    '/CustomerDetail',
                    {
                        customerID: customerRow.id,
                        name: name,
                        phoneNumber: phoneNumber
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('成功更新基本资料');
                    // fetchCustomers();
                    handleRefresh();
                    setEditCustomerModalOpen(false);
                } else {
                    errorAlert('发生错误');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setUpdateButtonDisabled(false);
            }
        };

        return (
            <Box style={{height: '80vh'}}>
                <Box>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='loginUserName' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.loginUserName")} : 
                            </Box>
                            <span style={{ color: 'grey', fontStyle: 'italic' }}>
                                指定用户登录帐号的用户名.
                            </span>
                        </Grid>
                        <Grid key='loginUserName' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="loginUserName"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={loginUserName}
                                onChange={(e) => setLoginUserName(e.target.value)}
                                disabled={true}
                                style={{backgroundColor: 'grey'}}
                            />
                        </Grid>
                    </Grid>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='name' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.name")} : 
                            </Box>
                            <span style={{ color: 'grey', fontStyle: 'italic' }}>
                                指定用户的名字
                            </span>
                        </Grid>
                        <Grid key='name' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="name"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={name}
                                onChange={(e) => setName(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='phoneNumber' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.phoneNumber")} : 
                            </Box>
                            <span style={{ color: 'grey', fontStyle: 'italic' }}>
                                指定用户的电话号码
                            </span>
                        </Grid>
                        <Grid key='phoneNumber' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="phoneNumber"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={phoneNumber}
                                onChange={(e) => setPhoneNumber(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Button
                        variant="contained"
                        sx={{
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '30px'
                        }}
                        onClick={submitUpdateCustomerProfile}
                        disabled={updateButtonDisabled}
                    >
                        {t("customer.confirmUpdate")}
                    </Button>
                </Box>
            </Box>
        );
    }

    function CreditScoreTab() {
        const [creditScore, setCreditScore] = useState(customerRow.creditScore);

        const [updateButtonDisabled, setUpdateButtonDisabled] = useState(false);
        const submitUpdateCreditScore = async () => {
            setUpdateButtonDisabled(true);

            try {
                const res = await axiosInstance.put(
                    '/CustomerDetail/CreditScore',
                    {
                        customerID: customerRow.id,
                        creditScore: creditScore
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('成功更新信用积分');
                    // fetchCustomers();
                    handleRefresh();
                    setEditCustomerModalOpen(false);
                } else {
                    errorAlert('发生错误');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setUpdateButtonDisabled(false);
            }
        };

        return (
            <Box style={{height: '80vh'}}>
                <Box>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='creditScore' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.creditScore")} :
                            </Box>
                        </Grid>
                        <Grid key='creditScore' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="creditScore"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={creditScore}
                                onChange={(e) => setCreditScore(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Button
                        variant="contained"
                        sx={{
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '30px'
                        }}
                        onClick={submitUpdateCreditScore}
                        disabled={updateButtonDisabled}
                    >
                        {t("customer.confirmUpdate")}
                    </Button>
                </Box>
            </Box>
        );
    }

    function CustomerPasswordTab() {
        const [customerPassword, setCustomerPassword] = useState('');

        const [updateButtonDisabled, setUpdateButtonDisabled] = useState(false);
        const submitUpdateCustomerPassword = async () => {
            setUpdateButtonDisabled(true);

            try {
                const res = await axiosInstance.put(
                    '/CustomerPassword',
                    {
                        customerID: customerRow.id,
                        newPassword: customerPassword,
                        isDisabled: null
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('成功更新用户密码');
                    // fetchCustomers();
                    handleRefresh();
                    setEditCustomerModalOpen(false);
                } else {
                    errorAlert('发生错误');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setUpdateButtonDisabled(false);
            }
        };

        return (
            <Box style={{height: '80vh'}}>
                <Box>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='customerPassword' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.loginPassword")} : 
                            </Box>
                            <span style={{ color: 'grey', fontStyle: 'italic' }}>
                                用户密码必须至少8个字符
                            </span>
                        </Grid>
                        <Grid key='customerPassword' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="customerPassword"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={customerPassword}
                                onChange={(e) => setCustomerPassword(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Button
                        variant="contained"
                        sx={{
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '30px'
                        }}
                        onClick={submitUpdateCustomerPassword}
                        disabled={updateButtonDisabled}
                    >
                        {t("customer.confirmUpdate")}
                    </Button>
                </Box>
            </Box>
        );
    }

    function WithdrawalPasswordTab() {
        const [withdrawalPassword, setWithdrawalPassword] = useState('');

        const [updateButtonDisabled, setUpdateButtonDisabled] = useState(false);
        const submitUpdateWithdrawalPassword = async () => {
            setUpdateButtonDisabled(true);

            try {
                const res = await axiosInstance.put(
                    '/CustomerDetail/WithdrawalPassword',
                    {
                        customerID: customerRow.id,
                        withdrawalPassword: withdrawalPassword
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('成功更新提款密码');
                    // fetchCustomers();
                    handleRefresh();
                    setEditCustomerModalOpen(false);
                } else {
                    errorAlert('发生错误');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setUpdateButtonDisabled(false);
            }
        };

        return (
            <Box style={{height: '80vh'}}>
                <Box>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='withdrawalPassword' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.withdrawalPassword")} : 
                            </Box>
                            <span style={{ color: 'grey', fontStyle: 'italic' }}>
                                取款密码必须至少8个字符
                            </span>
                        </Grid>
                        <Grid key='withdrawalPassword' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="withdrawalPassword"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={withdrawalPassword}
                                onChange={(e) => setWithdrawalPassword(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Button
                        variant="contained"
                        sx={{
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '30px'
                        }}
                        onClick={submitUpdateWithdrawalPassword}
                        disabled={updateButtonDisabled}
                    >
                        {t("customer.confirmUpdate")}
                    </Button>
                </Box>
            </Box>
        );
    }

    function WithdrawalDetailsTab() {
        const [bankVendorID, setBankVendorID] = useState(customerRow.bankVendorID);

        // Bank
        const [bankAccountHolderName, setBankAccountHolderName] = useState(customerRow.bankVendorID === 1 ? customerRow.bankHolderName : '');
        const [bankAccountNumber, setBankAccountNumber] = useState(customerRow.bankVendorID === 1 ? customerRow.bankAccount : '');
        const [secondBankAccountNumber, setSecondBankAccountNumber] = useState(customerRow.bankVendorID === 1 ? customerRow.secondBankAccountNumber : '');
        const [manualBankName, setManualBankName] = useState(customerRow.bankVendorID === 1 ? customerRow.manualBankName : '');

        // Wise 
        const [wiseBankAccountHolderName, setWiseBankAccountHolderName] = useState(customerRow.bankVendorID === 2 ? customerRow.bankHolderName : '');
        const [wiseBankAccountNumber, setWiseBankAccountNumber] = useState(customerRow.bankVendorID === 2 ? customerRow.bankAccount : '');
        const [wiseSecondBankAccountNumber, setWiseSecondBankAccountNumber] = useState(customerRow.bankVendorID === 2 ? customerRow.secondBankAccountNumber : '');

        // Revolut
        const [revolutBankAccountHolderName, setRevolutBankAccountHolderName] = useState(customerRow.bankVendorID === 3 ? customerRow.bankHolderName : '');
        const [revolutBankAccountNumber, setRevolutBankAccountNumber] = useState(customerRow.bankVendorID === 3 ? customerRow.bankAccount : '');
        const [revolutSecondBankAccountNumber, setRevolutSecondBankAccountNumber] = useState(customerRow.bankVendorID === 3 ? customerRow.secondBankAccountNumber : '');

        // N26
        const [n26BankAccountHolderName, setN26BankAccountHolderName] = useState(customerRow.bankVendorID === 4 ? customerRow.bankHolderName : '');
        const [n26SecondBankAccountNumber, setN26SecondBankAccountNumber] = useState(customerRow.bankVendorID === 4 ? customerRow.secondBankAccountNumber : '');

        // Crypto
        const [usdtBankAccountNumber, setUSDTBankAccountNumber] = useState(customerRow.bankVendorID === 5 ? customerRow.bankAccount : '');
        const [usdtManualBankName, setUSDTManualBankName] = useState(customerRow.bankVendorID === 5 ? customerRow.manualBankName : '');

        const [updateButtonDisabled, setUpdateButtonDisabled] = useState(false);
        const submitUpdateCustomerBankDetails = async () => {
            setUpdateButtonDisabled(true);
            let payload = {};
            
            try {
                const res = await axiosInstance.put(
                    '/CustomerBankDetails',
                    {
                        customerID: customerRow.id,
                        name: name,
                        phoneNumber: phoneNumber
                    },
                    {
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    }
                );
                if (res.status === 200) {
                    successAlert('成功更新基本资料');
                    // fetchCustomers();
                    handleRefresh();
                    setEditCustomerModalOpen(false);
                } else {
                    errorAlert('发生错误');
                }
            } catch (error) {
                console.log(error);
            } finally {
                setUpdateButtonDisabled(false);
            }
        };

        return (
            <Box style={{height: '80vh'}}>
                <Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px', fontWeight: 'bolder' }}>
                        {t("withdrawal.bankDetails")}
                    </Box>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='manualBankName' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.bankName")} : 
                            </Box>
                            {/* <span style={{ color: 'grey', fontStyle: 'italic' }}>
                                指定用户登录帐号的用户名.
                            </span> */}
                        </Grid>
                        <Grid key='manualBankName' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="manualBankName"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={manualBankName}
                                onChange={(e) => setManualBankName(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='bankAccountHolderName' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.bankAccountHolder")} : 
                            </Box>
                            {/* <span style={{ color: 'grey', fontStyle: 'italic' }}>
                                指定用户登录帐号的用户名.
                            </span> */}
                        </Grid>
                        <Grid key='bankAccountHolderName' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="bankAccountHolderName"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={bankAccountHolderName}
                                onChange={(e) => setBankAccountHolderName(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    {/* <Grid item container pr={{ md: '5px' }}>
                        <Grid key='bankAccountNumber' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                银行账户号 : 
                            </Box>
                        </Grid>
                        <Grid key='bankAccountNumber' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="bankAccountNumber"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={bankAccountNumber}
                                onChange={(e) => setBankAccountNumber(e.target.value)}
                            />
                        </Grid>
                    </Grid> */}
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='secondBankAccountNumber' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                {t("customer.IBAN")} : 
                            </Box>
                            {/* <span style={{ color: 'grey', fontStyle: 'italic' }}>
                                指定用户登录帐号的用户名.
                            </span> */}
                        </Grid>
                        <Grid key='secondBankAccountNumber' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="secondBankAccountNumber"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={secondBankAccountNumber}
                                onChange={(e) => setSecondBankAccountNumber(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Divider style={{marginTop: '20px', marginBottom: '20px'}} />
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='wiseBankAccountHolderName' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                Wise 用户全名 : 
                            </Box>
                            {/* <span style={{ color: 'grey', fontStyle: 'italic' }}>
                                指定用户登录帐号的用户名.
                            </span> */}
                        </Grid>
                        <Grid key='wiseBankAccountHolderName' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="wiseBankAccountHolderName"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={wiseBankAccountHolderName}
                                onChange={(e) => setWiseBankAccountHolderName(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='wiseBankAccountNumber' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                Wise Email : 
                            </Box>
                            {/* <span style={{ color: 'grey', fontStyle: 'italic' }}>
                                指定用户登录帐号的用户名.
                            </span> */}
                        </Grid>
                        <Grid key='wiseBankAccountNumber' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="wiseBankAccountNumber"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={wiseBankAccountNumber}
                                onChange={(e) => setWiseBankAccountNumber(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='wiseSecondBankAccountNumber' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                Wise IBAN : 
                            </Box>
                            {/* <span style={{ color: 'grey', fontStyle: 'italic' }}>
                                指定用户登录帐号的用户名.
                            </span> */}
                        </Grid>
                        <Grid key='wiseSecondBankAccountNumber' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="wiseSecondBankAccountNumber"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={wiseSecondBankAccountNumber}
                                onChange={(e) => setWiseSecondBankAccountNumber(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Divider style={{marginTop: '20px', marginBottom: '20px'}} />
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='revolutBankAccountHolderName' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                Revolut 用户全名 : 
                            </Box>
                            {/* <span style={{ color: 'grey', fontStyle: 'italic' }}>
                                指定用户登录帐号的用户名.
                            </span> */}
                        </Grid>
                        <Grid key='revolutBankAccountHolderName' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="revolutBankAccountHolderName"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={revolutBankAccountHolderName}
                                onChange={(e) => setRevolutBankAccountHolderName(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='revolutBankAccountNumber' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                Revolut Revtag : 
                            </Box>
                            {/* <span style={{ color: 'grey', fontStyle: 'italic' }}>
                                指定用户登录帐号的用户名.
                            </span> */}
                        </Grid>
                        <Grid key='revolutBankAccountNumber' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="revolutBankAccountNumber"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={revolutBankAccountNumber}
                                onChange={(e) => setRevolutBankAccountNumber(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='revolutSecondBankAccountNumber' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                Revolut IBAN : 
                            </Box>
                            {/* <span style={{ color: 'grey', fontStyle: 'italic' }}>
                                指定用户登录帐号的用户名.
                            </span> */}
                        </Grid>
                        <Grid key='revolutSecondBankAccountNumber' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="revolutSecondBankAccountNumber"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={revolutSecondBankAccountNumber}
                                onChange={(e) => setRevolutSecondBankAccountNumber(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Divider style={{marginTop: '20px', marginBottom: '20px'}} />
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='n26BankAccountHolderName' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                N26 全名 : 
                            </Box>
                            {/* <span style={{ color: 'grey', fontStyle: 'italic' }}>
                                指定用户登录帐号的用户名.
                            </span> */}
                        </Grid>
                        <Grid key='n26BankAccountHolderName' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="n26BankAccountHolderName"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={n26BankAccountHolderName}
                                onChange={(e) => setN26BankAccountHolderName(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='n26SecondBankAccountNumber' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                N26 IBAN : 
                            </Box>
                            {/* <span style={{ color: 'grey', fontStyle: 'italic' }}>
                                指定用户登录帐号的用户名.
                            </span> */}
                        </Grid>
                        <Grid key='n26SecondBankAccountNumber' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="n26SecondBankAccountNumber"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={n26SecondBankAccountNumber}
                                onChange={(e) => setN26SecondBankAccountNumber(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Divider style={{marginTop: '20px', marginBottom: '20px'}} />
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='usdtBankAccountNumber' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                钱包地址 : 
                            </Box>
                            {/* <span style={{ color: 'grey', fontStyle: 'italic' }}>
                                指定用户登录帐号的用户名.
                            </span> */}
                        </Grid>
                        <Grid key='usdtBankAccountNumber' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="usdtBankAccountNumber"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={usdtBankAccountNumber}
                                onChange={(e) => setUSDTBankAccountNumber(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    <Grid item container pr={{ md: '5px' }}>
                        <Grid key='usdtManualBankName' xs={5} sx={{ mt: 2 }} style={{alignContent: 'center'}}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                区块链/网络 : 
                            </Box>
                            {/* <span style={{ color: 'grey', fontStyle: 'italic' }}>
                                指定用户登录帐号的用户名.
                            </span> */}
                        </Grid>
                        <Grid key='usdtManualBankName' xs={7} sx={{ mt: 2 }}>
                            <TextField
                                required
                                name="usdtManualBankName"
                                type="text"
                                fullWidth
                                variant="outlined"
                                value={usdtManualBankName}
                                onChange={(e) => setUSDTManualBankName(e.target.value)}
                            />
                        </Grid>
                    </Grid>
                    {/* <Button
                        variant="contained"
                        sx={{
                            display: 'block',
                            mx: 'auto',
                            width: '150px',
                            backgroundColor: deepPurple[500],
                            marginTop: '30px'
                        }}
                        // onClick={submitUpdateCustomerProfile}
                        disabled={updateButtonDisabled}
                    >
                        确认更新
                    </Button> */}
                </Box>
            </Box>
        );
    }

    return (
        <>
            {/* <Button
                onClick={handleOpenModal}
                sx={{
                    border: 'none',
                    backgroundColor: deepPurple[500],
                    width: 'fit-content',
                    height: 'fit-content',
                    color: 'white',
                    '&.Mui-selected, &.Mui-selected:hover': {
                        color: deepPurple[500],
                        backgroundColor: 'white'
                    },
                    fontSize: '12px'
                }}
            >
                {buttonName}
            </Button> */}
            <Modal
                open={editCustomerModalOpen}
                onClose={() => setEditCustomerModalOpen(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={style}>
                    <Box
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between'
                        }}
                    >
                        <Typography id="modal-modal-title" variant="h3" component="h2">
                            {t("customer.editProfile")}
                        </Typography>
                        <Cancel onClick={() => setEditCustomerModalOpen(false)} sx={{ width: '30px', height: '30px' }} />
                    </Box>
                    <Box
                        id="modal-modal-description"
                        sx={{
                            overflowY: 'auto'
                        }}
                    >
                        <Box
                            sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                width: '100%' 
                            }}
                        >
                            <StyledToggleButtonGroup
                                value={view}
                                exclusive
                                onChange={handleChange}
                                sx={{
                                    flexDirection: { xs: 'column', md: 'row' }
                                }}
                            >
                                <StyledToggleButton value="personalDetails" aria-label="deposit">
                                    {t("customer.personalDetails")}
                                </StyledToggleButton>
                                <StyledToggleButton value="creditScore" aria-label="withdrawal">
                                    {t("customer.creditScore")}
                                </StyledToggleButton>
                                <StyledToggleButton value="loginPassword" aria-label="withdrawal">
                                    {t("customer.loginUserName")}
                                </StyledToggleButton>
                                <StyledToggleButton value="withdrawalPassword" aria-label="withdrawal">
                                    {t("customer.withdrawalPassword")}
                                </StyledToggleButton>
                                <StyledToggleButton value="bankDetails" aria-label="withdrawal">
                                    {t("customer.bankDepositDetails")}
                                </StyledToggleButton>
                            </StyledToggleButtonGroup>
                        </Box>
            
                        {view === 'personalDetails' && (
                            <>
                                <PersonalDetailsTab />
                            </>
                        )}
                        {view === 'creditScore' && (
                            <>
                                <CreditScoreTab />
                            </>
                        )}
                        {view === 'loginPassword' && (
                            <>
                                <CustomerPasswordTab />
                            </>
                        )}
                        {view === 'withdrawalPassword' && (
                            <>
                                <WithdrawalPasswordTab />
                            </>
                        )}
                        {view === 'bankDetails' && (
                            <>
                                <WithdrawalDetailsTab />
                            </>
                        )}
                    </Box>
                </Box>
            </Modal>
        </>
    );
};

export default CustomerTasklistModal;